/**
 * JSON fetch helper for admin Vue islands (CSRF + Laravel JSON errors).
 */
export default async function adminFetch(url, { method = 'GET', body, signal } = {}) {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
    const headers = {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': token,
    };
    if (body !== undefined && body !== null) {
        headers['Content-Type'] = 'application/json';
    }
    const response = await fetch(url, {
        method,
        headers,
        credentials: 'same-origin',
        body: body !== undefined && body !== null ? JSON.stringify(body) : undefined,
        signal,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        const details = data.errors ? Object.values(data.errors).flat().join(' ') : '';
        const error = new Error(details || data.message || 'Richiesta non riuscita.');
        error.status = response.status;
        error.payload = data;
        throw error;
    }

    return data;
}
